import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TaskService } from '../../../../services';
import { MessageService } from 'primeng';
import { JobScreenOdometerReadingsTask } from '../../../../interfaces/screen-specific/job-screen';
import { IOdometerReading } from '../../../../interfaces/odometer-reading';
import { Message } from '../../../../classes/Message';

@Component({
  selector: 'job-screen-odometer-readings',
  templateUrl: './job-screen-odometer-readings.component.html',
  styleUrls: ['./job-screen-odometer-readings.component.scss'],
})
export class JobScreenOdometerReadingsComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() odometerTask: JobScreenOdometerReadingsTask;
  @Input() organisationTypeId: number;

  isShownOdometerDialog: boolean;
  odometerEdited: IOdometerReading = <any>{};
  awaitingAllocation = false;

  constructor(
    public fb: FormBuilder,
    public taskService: TaskService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {}

  async ngAfterViewInit() {}

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.odometerTask) {
      this.awaitingAllocation = this.odometerTask.driverId == null;
      this.updateMileValues();
    }
  }

  showOdometerReadingDialog(isPickup: boolean) {
    this.odometerEdited = {
      taskId: this.odometerTask.id,
      isPickup: isPickup,
      odometer: isPickup ? this.odometerTask.pickupOdometer : this.odometerTask.dropoffOdometer,
    };

    this.isShownOdometerDialog = true;
  }

  get editedOdometerValid(): boolean {
    return this.odometerEdited.odometer > 0 && !this.editedOdometerIsDropoffLessPickup;
  }

  get editedOdometerIsDropoffLessPickup(): boolean {
    return (
      this.odometerTask &&
      !this.odometerEdited.isPickup &&
      this.odometerEdited.odometer <= this.odometerTask.pickupOdometer
    );
  }

  saveOdometerReading() {
    this.taskService
      .saveOdometerReading(this.odometerEdited)
      .then(() => {
        this.updateOdometerValues();

        this.isShownOdometerDialog = false;
        this.messageService.add(
          Message.Success('Odometer reading successfully changed.', 'Change Odometer Reading'),
        );
      })
      .catch(() => {
        this.messageService.add(
          Message.Error(
            'An error occurred while changing odometer reading. Try again.',
            'Change Odometer Reading',
          ),
        );
      });
  }

  updateOdometerValues(): void {
    if (this.odometerEdited.isPickup) {
      this.odometerTask.pickupOdometer = this.odometerEdited.odometer;
    } else {
      this.odometerTask.dropoffOdometer = this.odometerEdited.odometer;
    }

    this.updateMileValues();
  }

  updateMileValues(): void {
    this.odometerTask.estimatedMiles = (this.odometerTask.distance ?? 0) * 0.000621;
    this.odometerTask.actualMiles =
      this.odometerTask.dropoffOdometer - this.odometerTask.pickupOdometer;
    this.odometerTask.milesDiff = Math.abs(
      (this.odometerTask.distance ?? 0) * 0.000621 -
        (this.odometerTask.dropoffOdometer - this.odometerTask.pickupOdometer),
    );
  }

  /**
   * Formulas
   * 100 x (A - B) / (A+B)/2
   */
  get differencePercent(): number {
    if (!this.odometerTask) return 0;

    const actualMiles = this.odometerTask.actualMiles;
    const estimatedMiles = this.odometerTask.estimatedMiles;

    const calculatedPart1 = estimatedMiles - actualMiles;
    const calculatedPart2 = (estimatedMiles + actualMiles) / 2;
    const result = (calculatedPart1 / calculatedPart2) * 100;
    return Math.abs(result);
  }

  get displayRedAlert(): string {
    return this.differencePercent > 15 ? 'text-danger' : '';
  }
}
